// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 203) return "static/chunks/e3762d72-ee78ba5b245f9ffa.js";
	if (chunkId === 16) return "static/chunks/16-d2c82549872732eb.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"3c5379fc7377331c","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"6a831ea65f0b71b6","367":"065c5ec473bc4ad4","639":"0801a5c84dd49092","748":"ae4ca8748d912786"}[chunkId] + ".js";
};